// ─── TRANSFORMATIONS DATA ─────────────────────────────────────────────────────
// Smart loader: add new objects here to extend the transformations gallery
export const TRANSFORMATIONS_DIRECTORY = [
  {
    id: "t001",
    clientName: "Client D.",
    program: "Body Recomp",
    stat: "-",
    statLabel: "Progress",
    beforeAlt: "Client D. before transformation",
    afterAlt: "Client D. after transformation",
    beforeUrl: require("../assets/dib_before.jpeg"),
    afterUrl: require("../assets/dib_after.jpeg"),
  },
  {
    id: "t002",
    clientName: "Grace",
    program: "Strength + Shape",
    stat: "-",
    statLabel: "Progress",
    beforeAlt: "Grace before transformation",
    afterAlt: "Grace after transformation",
    beforeUrl: require("../assets/grace_before.jpeg"),
    afterUrl: require("../assets/grace_after.jpeg"),
  },
  {
    id: "t003",
    clientName: "Client G.",
    program: "Lean Build",
    stat: "-",
    statLabel: "Progress",
    beforeAlt: "Client G. before transformation",
    afterAlt: "Client G. after transformation",
    beforeUrl: require("../assets/guy_before.jpeg"),
    afterUrl: require("../assets/guy_after.jpeg"),
  },
  {
    id: "t004",
    clientName: "Client A.",
    program: "Body Recomp",
    stat: "-",
    statLabel: "Progress",
    beforeAlt: "Client A. before transformation",
    afterAlt: "Client A. after transformation",
    beforeUrl: require("../assets/before.jpeg"),
    afterUrl: require("../assets/after.jpeg"),
  },
];
